<!--
 * @Author: lbh
 * @Date: 2022-07-30 15:13:18
 * @LastEditors: lbh
 * @LastEditTime: 2025-10-18 15:02:54
 * @Description: 底部條款
-->
<template>
  <div class="footer-box">
    <div class="cell">
      <div class="l" @click="getResource(1)">{{ $t('shop.Terms') }}</div>
      <div class="c"></div>
      <div class="r" @click="getResource(2)">
        {{ $t('shop.Privacy_Policy') }}
      </div>
    </div>
    <!-- 盛記酒家 -->
    <div v-if="isSingKee" class="t">
      {{
        $t(
          'shop._2024_Lucky_Castle_Limited_All_rights_reserved_No_reproduction_allowed_'
        )
      }}
    </div>
    <div v-else class="t">
      {{
        $t(
          'shop._2022_Gingersoft_Limited_All_rights_reserved_No_reproduction_allowed_'
        )
      }}
    </div>

    <!-- 條款 -->
    <van-popup v-model="showPopup" @open="openPop" @closed="closePop">
      <div class="popup-box">
        <div class="title" v-text="popData.resourceName"></div>
        <div class="content" v-html="popData.content"></div>
        <div class="btn">
          <van-button
            color="var(--themeColor)"
            @click="showPopup = false"
            block
            >{{ $t("shop.OK") }}</van-button
          >
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "self-footer",
  data() {
    return {
      showPopup: false,
      useData: {},
      yinData: {},
      popData: {},
    };
  },
  computed: {
    isSingKee() {
      return location.origin.includes("singkee.ricepon");
    },
  },
  methods: {
    getResource(t) {
      if (t == 1) {
        if (this.useData.id) {
          this.popData = this.useData;
          this.showPopup = true;
          return;
        }
      } else if (t == 2) {
        if (this.yinData.id) {
          this.popData = this.yinData;
          this.showPopup = true;
          return;
        }
      }
      this.$util.getResource.request(
        { type: t == 1 ? 18 : 17 },
        (res) => {
          if (res.code == 1) {
            let data = res.data || [];
            if (data.length > 0) {
              let item = data[0];
              if (t == 1) this.useData = item;
              else this.yinData = item;
              this.popData = item;
              if(this.isSingKee){
                item.content = item.content.replace(/Ricepon飯糰/g, '幸堡有限公司');
                item.content = item.content.replace(/Gingersoft Limited/g, '幸堡有限公司');
              }
              this.showPopup = true;
            }
          }
        },
        (err) => {}
      );
    },
    openPop() {
      this.$emit("onOpen", true);
    },
    closePop() {
      this.$emit("onOpen", false);
    },
  },
};
</script>

<style lang="less" scoped>
.footer-box {
  background-color: #fff;
  box-shadow: 0px -3px 5px 0px rgba(0, 0, 0, 0.03);
  .cell {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 0 15px;
    border-bottom: 1px solid #dddddd;
    .l {
      font-size: var(--font13);
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      border-bottom: 1px solid #333333;
    }
    .c {
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: #000;
      margin: 0 15px;
    }
    .r {
      font-size: var(--font13);
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      border-bottom: 1px solid #333333;
    }
  }
  .t {
    font-size: var(--font13);
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    text-align: center;
    padding: 12px 0 15px;
  }
  & /deep/ .van-popup {
    border-radius: 6px;
  }
  .popup-box {
    width: calc(100vw - 40px);
    height: calc(100vh - 160px);
    border-radius: 6px;
    .title {
      height: 40px;
      line-height: 40px;
      font-weight: 900;
      color: #333333;
      text-align: center;
    }
    .content {
      padding: 10px;
      height: calc(100% - 120px);
      overflow-x: hidden;
      overflow-y: auto;
    }
    .btn {
      height: 40px;
      padding: 10px;
      & /deep/ .van-button {
        height: 40px;
      }
    }
  }
}
</style>
